import React, { useEffect, useState } from 'react';
import './LoadingSpinner.scss';

const LoadingSpinner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const showTimeout = setTimeout(() => {
      setShow(true);
    }, 200);

    return () => {
      clearTimeout(showTimeout);
    };
  }, []);

  if (!show) {
    return null;
  }

  return (
    <div className="spinner-container">
      <div className="spinner">Loading...</div>
    </div>
  );
};

export default LoadingSpinner;
